import {FulltextSearch} from '@/api/meta/filters';
import {autoImplement} from '@/util';
import moment from 'moment';
import {ApiFile} from './File';

export interface ApiContactHistory {
  KundenNr: number,
  Nr: number,
  KundeName: string,
  Art: string,
  Disponent: string,
  AnlageDatum: string,
  AnlageUhrzeit: string,
  AnlageBediener: string,
  Erledigt: boolean,
  Prioritaet: null,
  Thema: string,
  Inhalt: string | null,
  WiedervorlageDatum: string,
  WiedervorlageUhrzeit: string,
  Ansprechpartner: Array<{
    Vorname: string,
    Nachname: string,
    Nummer: number,
    AnsprechpartnerNr: number
  }>,
  Dateien: {
    Values: ApiFile[],
  },
  Dokumente: {
    Values: ApiFile[],
  },
  Bediener: Array<{
    Erledigt: {
      Status: boolean,
    },
    Gelesen: {
      Status: boolean,
    },
    Bediener: string,
    WiedervorlageDatum: string
    WiedervorlageUhrzeit: string
  }>
}

export interface ApiContactHistorySubmitData {
  Art: string,
  Ansprechpartner: Array<{AnsprechpartnerNr: number}>,
  Disponent: string|null,
  Thema: string,
  Inhalt: string
}

export interface ApiContactHistoryBedienerSubmitData {
  Bediener: string,
  Gelesen: boolean,
  Erledigt: boolean,
  WiedervorlageDatum: string,
  WiedervorlageUhrzeit: string,
}

export interface ContactHistoryFilters {
  KundenNr?: number;
  Erledigt?: boolean;
  Fulltext$Fulltext: FulltextSearch;
  Art$In?: string[];
  Ansprechpartner$Any?: {
    AnsprechpartnerNr?: number | null
  }
}

export interface DetailContactHistoryFilters {
  KundenNr?: number;
}

export function formatDatum(datum: string, time: string, showTime = true) {
  const outputFormat = showTime ? 'DD.MM.YYYY HH:mm' : 'DD.MM.YYYY';
  if (time.length > 10) {
    return moment(time).format(outputFormat); // TODO: Check if timezone behaves as expected
  }
  const timeSplit = time.split(':');
  return moment(datum).hour(Number(timeSplit[0])).minute(Number(timeSplit[1])).format(outputFormat); // TODO: Check if timezone behaves as expected
}

export default class ContactHistory extends autoImplement<ApiContactHistory>() {
  static fromApi(apiContactHistory: ApiContactHistory): ContactHistory {
    return new ContactHistory(apiContactHistory);
  }
  get icon() {
    return this.Erledigt ? 'mdi-check' : null;
  }
  get color() {
    return this.Erledigt ? 'success' : 'error';
  }
  get typeIcon() {
    switch (this.Art) {
      case 'T': // Telefonat
        return 'mdi-phone';
      case 'AN': // Angebote
        return 'mdi-file-document';
      case 'AU': // Auftrag
        return 'mdi-file-document-check';
      case 'RE': // Rechnung
        return 'mdi-receipt-text';
      case 'EL': // Eingangslieferschein
        return 'mdi-truck-check';
    }
    return 'mdi-file-document';
  }
  get AnlageDatumFormatted() {
    return formatDatum(this.AnlageDatum, this.AnlageUhrzeit);
  }
  get WiedervorlageDatumFormatted() {
    return formatDatum(this.WiedervorlageDatum, this.WiedervorlageUhrzeit);
  }
  get AnsprechpartnerFormatted() {
    if (this.Ansprechpartner.length > 0) {
      return `${this.Ansprechpartner[0].Vorname} ${this.Ansprechpartner[0].Nachname}`;
    }
  }
}
